

import { GamePlanCard } from '../GamePlanCard';
import { GamePlan } from '@/types/gamePlanner';
import { EmptyPlansState } from './EmptyPlansState';

interface GamePlansListProps {
  gamePlans: GamePlan[];
  loading: boolean;
  onEdit: (id: string) => void;
  onShare: (id: string) => void;
  onDelete: (id: string) => void;
  onChangeDetails: (id: string) => void;
  onConvertToTemplate: (id: string) => void;
}

export function GamePlansList({
  gamePlans,
  loading,
  onEdit,
  onShare,
  onDelete,
  onChangeDetails,
  onConvertToTemplate
}: GamePlansListProps) {
  if (!gamePlans || gamePlans.length === 0) {
    return <EmptyPlansState loading={loading} />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {gamePlans.map((plan) => (
        <GamePlanCard
          key={plan.id}
          id={plan.id}
          name={plan.name}
          description={plan.description}
          isTemplate={plan.is_template}
          isAdmin={plan.is_admin_template}
          onEdit={onEdit}
          onShare={onShare}
          onDelete={onDelete}
          onChangeDetails={onChangeDetails}
          onConvertToTemplate={onConvertToTemplate}
        />
      ))}
    </div>
  );
}
